import { render, staticRenderFns } from "./ConfigurableCarousel.vue?vue&type=template&id=d0c872c2&scoped=true"
import script from "./ConfigurableCarousel.vue?vue&type=script&lang=js"
export * from "./ConfigurableCarousel.vue?vue&type=script&lang=js"
import style0 from "./ConfigurableCarousel.vue?vue&type=style&index=0&id=d0c872c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c872c2",
  null
  
)

export default component.exports